//Este es un pedido de Jime para cargar las viandas tarde en la semana.

//No modifico el codigo actual para no generar un bug innecesario en el modulo de viandas (Por eso el codigo repetido)

import { useEffect, useMemo, useState } from "react";
import { UrlApi } from "../../../services/apirest";
import { useToast } from "../../../Hooks/UseToast";
import {
  Autocomplete,
  Box,
  Button,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import MostrarMenuSemanal from "./MostrarMenuSemanal";
import Navbar from "../../Navbar";
import SaveIcon from "@mui/icons-material/Save";
import moment from "moment";
import { GenerarEstaSemana } from "./FechasEstaSemana.js";

const USERNAMES_NETIZAR = [
  "nicolaspascucci",
  "ignaciobastianelli",
  "micaelairibarren",
  "federicopereyra",
  "mperea",
  "eduardo",
  "amichel",
  "joaquinbaldellou",
  "guillermosedran",
  "cgrosso",
];

const USERNAMES_INVITADOS = [
  "invitado1",
  "invitado2",
  "invitado3",
  "invitado4",
  "invitado5",
  "invitado6",
  "invitado7",
  "invitado8",
  "invitado9",
];

const ALLOWED_SUCURSALES = [8, 1000];

const SeleccionarViandasEnLaMismaSemana = () => {
  const [userOptions, setUserOptions] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [rotativeMenus, setRotativeMenus] = useState([]);
  const [ejecutiveMenus, setEjecutiveMenus] = useState([]);
  const [userSelection, setUserSelection] = useState({});
  const [selectedWeek, setSelectedWeek] = useState(0);
  const [cantidadDeDiasDelaSemana, setCantidadDeDiasDeLaSemana] = useState(0);

  const sucursal = useMemo(() => localStorage.getItem("sucursal"), []); //idSucursal

  const handleChangeUser = (event, value) => {
    const username = value ? value.username : null;
    setSelectedUser(username);
  };

  const { showToast, Toast } = useToast();

  const semanaCompleta = useMemo(() => {
    return GenerarEstaSemana(selectedWeek);
  }, [selectedWeek]);

  //Para arreglar: hacer un endpoint que agarre la semana en la que se esta generando en vez de la semana actual....
  const checkFreeDaysOfWeek = async () => {
    const response = await fetch(
      `${UrlApi}/viandas/menu/getWeek/${semanaCompleta[0].fecha}`
    );
    if (!response.ok) return;
    const data = await response.json();

    const dataParsed = data.map((item) => {
      const [dia, fecha] = Object.entries(item)[0];
      return {
        dia,
        fecha:
          fecha !== "feriado"
            ? moment(fecha, "DD/MM/YYYY").format("YYYY-MM-DD")
            : "feriado",
      };
    });
    const initialSelection = {};
    dataParsed.forEach(({ fecha }) => {
      if (fecha !== "feriado") initialSelection[fecha] = undefined;
    });

    setCantidadDeDiasDeLaSemana(Object.keys(initialSelection).length);
    setUserSelection(initialSelection);
  };

  const getEjecutiveMenus = async () => {
    try {
      let response = await fetch(
        `${UrlApi}/viandasfech/obtenerElMenuEjecutivoDeLaSemana/${semanaCompleta[0].fecha}`
      );
      response = await response.json();
      setEjecutiveMenus(
        response?.sort((a, b) => new Date(a.fecha) - new Date(b.fecha))
      );
    } catch (err) {
      console.error("Error al traer los datos del menu ejecutivo");
      showToast("Error al consultar el menu ejecutivo", "error");
    }
  };

  const getRotativeMenus = async () => {
    try {
      let response = await fetch(
        `${UrlApi}/viandasfech/obtenerElMenuRotativoDeLaSemana/${semanaCompleta[0].fecha}`
      );
      response = await response.json();
      setRotativeMenus(response);
    } catch (err) {
      console.error("Error al traer los datos del menu rotativo");
      showToast("Error al consultar el menu rotativo", "error");
    }
  };

  const getExistingOrders = async (initDate, endDate, username) => {
    const response = await fetch(
      `${UrlApi}/viandasfech/existepedidos/${initDate}_${endDate}?username=${username}`
    );

    if (!response.ok) return;

    const data = await response.json();

    const filtredData = data.map(({ id_pedidos, id_menu, fecha }) => ({
      id_pedidos,
      id_menu,
      fecha: fecha.split("T")[0],
    }));
    const selectionObj = Object.fromEntries(
      semanaCompleta.map(({ fecha }) => {
        const match = filtredData.find((item) => item.fecha === fecha);
        return [
          fecha,
          {
            id_menu: match ? match.id_menu : undefined,
            id_pedidos: match ? match.id_pedidos : undefined,
          },
        ];
      })
    );

    const hasAtLeastOneValue = Object.values(selectionObj).some(
      (item) => item.id_menu !== undefined
    );

    if (hasAtLeastOneValue) {
      const seleccionFinal = Object.fromEntries(
        Object.entries(selectionObj).filter(
          ([_, value]) => value?.id_menu !== undefined
        )
      );
      setUserSelection(seleccionFinal);
    } else {
      setUserSelection({});
    }
  };

  const checkAvailableButton = () => {
    const diasSeleccionados = Object.values(userSelection).filter(
      (val) => val && val !== 0 && val !== undefined
    ).length;

    return diasSeleccionados !== cantidadDeDiasDelaSemana;
  };

  const getUsers = async () => {
    const request = await fetch(`${UrlApi}/viandas/menu/usersMasInvitados`);

    const data = await request.json();

    if (!data) {
      showToast("No se encontraron usuarios", "error");
      return;
    }

    setUserOptions(Array.isArray(data) ? data : []);
  };

  useEffect(() => {
    getRotativeMenus();
    getEjecutiveMenus();
    checkFreeDaysOfWeek();
    getUsers();
  }, [selectedWeek]);

  useEffect(() => {
    const init = async () => {
      if (selectedUser) {
        await getExistingOrders(
          semanaCompleta[0].fecha,
          semanaCompleta[4].fecha,
          selectedUser
        );
      }
    };
    init();
  }, [selectedUser, selectedWeek]);

  const handleSelect = (fecha, tipo, valor) => {
    const fechaFormateada = fecha.split("T")[0];

    setUserSelection((prev) => ({
      ...prev,
      [fechaFormateada]: {
        ...prev[fechaFormateada],
        [tipo]: valor,
      },
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let sucursalSegura = USERNAMES_NETIZAR.includes(selectedUser)
        ? 1000
        : USERNAMES_INVITADOS.includes(selectedUser)
        ? 8
        : ALLOWED_SUCURSALES.includes(Number(sucursal))
        ? sucursal
        : 8;

      const datos = {
        pedidosObj: userSelection,
        username: selectedUser,
        id_sucursal: sucursalSegura,
      };
      const response = await fetch(`${UrlApi}/viandas/pedidos/sync`, {
        method: "PUT",
        body: JSON.stringify(datos),
        headers: { "Content-Type": "application/json" },
      });
      if (!response.ok)
        throw new Error(
          "Ocurrio un error al guardar las viandas. Intentelo nuevamente"
        );
      // navigate("/viandas/confirmacion", { //No lo llevo a la pantalla de confirmacion para que no tegna que estar volviendo constantemente para atras si necestia cargar muchos pedidos juntos
      //   state: {
      //     username: selectedUser,
      //     pedidos: userSelection,
      //     menus: [...rotativeMenus, ...ejecutiveMenus],
      //   },
      // });

      setSelectedUser(null);
      setUserSelection({});

      showToast(
        `El pedido para ${selectedUser} se guardo con exito!`,
        "success"
      );
    } catch (err) {
      console.error(err);
      showToast(`${err}`, "error");
    }
  };

  return (
    <>
      <Navbar />
      <Container
        sx={{
          width: "100%",
          px: "auto",
          mx: "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 3,
        }}
      >
        <Typography sx={{ mt: 4 }} variant="h3">
          <Typography
            component="span"
            variant="h3"
            sx={{ color: "#3e513b", mt: 4 }}
          >
            Hola
          </Typography>
          , seleccioná tus viandas de la semana
        </Typography>
        <Box>
          <FormControl fullWidth sx={{ mb: 4, maxWidth: 300 }}>
            <InputLabel>Seleccionar Semana</InputLabel>
            <Select
              value={selectedWeek}
              label="Seleccionar Semana"
              onChange={(e) => {
                setSelectedWeek(e.target.value);
                setSelectedUser(null);
                setUserSelection({});
              }}
            >
              <MenuItem value={-7}>Semana Anterior</MenuItem>
              <MenuItem value={0}>Esta Semana</MenuItem>
              <MenuItem value={7}>Semana Próxima</MenuItem>
            </Select>
          </FormControl>

          <Autocomplete
            disablePortal
            options={userOptions}
            getOptionLabel={(option) => option.username}
            value={userOptions.find((u) => u.username === selectedUser) || null}
            onChange={handleChangeUser}
            sx={{ width: 300 }}
            renderInput={(params) => <TextField {...params} label="Usuarios" />}
          />
        </Box>
        <MostrarMenuSemanal
          handleSelect={handleSelect}
          ejecutiveMenus={ejecutiveMenus}
          rotativeMenus={rotativeMenus}
          userSelection={userSelection}
        />
        <Button
          onClick={handleSubmit}
          disabled={checkAvailableButton() || !selectedUser}
          sx={{
            backgroundColor: "#3e513b",
            py: 1.5,
            px: 4,
            borderRadius: 2,
            mb: 10,
            mt: 4,
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: "#2d3e2a",
            },
          }}
          variant="contained"
          color="primary"
          startIcon={<SaveIcon />}
        >
          Confirmar pedido
        </Button>
      </Container>
      {Toast}
    </>
  );
};

export default SeleccionarViandasEnLaMismaSemana;
